//Functions
import {
    App as AnalogSetpoint,
    AppTemp as AnalogSetpointTemp,
    AppHum as AnalogSetpointHum,
    AppSupPress as AnalogSetpointSupPress,
    AppExPress as  AnalogSetpointExPress
} from './AnalogSetpoint/appDeclaration';

import { App as DigitalSetpoint } from './DigitalSetpoint/appDeclaration';
import { App as Scheduler } from './Scheduler/appDeclaration';
import { App as ControlledScheduler } from './ControlledScheduler/appDeclaration';
import { App as ShiftFunction } from './ShiftFunction/appDeclaration';
import { App as PID } from './PID/appDeclaration';
import { App as ControlledPID } from './ControlledPID/appDeclaration';
import { App as Controlled2Point } from './Controlled2Point/appDeclaration';
import { App as Calendar } from './Calendar/appDeclaration'
import { App as ShiftFunction2Point } from './ShiftFunction2Point/appDeclaration'
import { App as ShiftFunction4Point } from './ShiftFunction4Point/appDeclaration'
import { App as ControlledShiftFunction4Point } from './ControlledShiftFunction4Point/appDeclaration'
import { App as ControlledCalendar } from './ControlledCalendar/appDeclaration'

export const Apps = {
    [AnalogSetpoint.schema]: AnalogSetpoint,
    [AnalogSetpointTemp.schema]: AnalogSetpointTemp,
    [AnalogSetpointHum.schema]: AnalogSetpointHum,
    [AnalogSetpointSupPress.schema]: AnalogSetpointSupPress,
    [AnalogSetpointExPress.schema]: AnalogSetpointExPress,
    [DigitalSetpoint.schema]: DigitalSetpoint,
    [Scheduler.schema]: Scheduler,
    [ShiftFunction.schema]: ShiftFunction,
    [PID.schema]: PID,
    [ControlledPID.schema]: ControlledPID,
    [Controlled2Point.schema]: Controlled2Point,
    [Calendar.schema]: Calendar,
    [ShiftFunction2Point.schema]: ShiftFunction2Point,
    [ShiftFunction4Point.schema]: ShiftFunction4Point,
    [ControlledShiftFunction4Point.schema]: ControlledShiftFunction4Point,
    [ControlledScheduler.schema]: ControlledScheduler,
    [ControlledCalendar.schema]: ControlledCalendar,
}